import { render, staticRenderFns } from "./MainInputs.vue?vue&type=template&id=15bc86b2"
import script from "./MainInputs.vue?vue&type=script&lang=js"
export * from "./MainInputs.vue?vue&type=script&lang=js"
import style0 from "./MainInputs.vue?vue&type=style&index=0&id=15bc86b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports